import { render, staticRenderFns } from "./LearnHome.vue?vue&type=template&id=0e014972"
import script from "./LearnHome.vue?vue&type=script&lang=js"
export * from "./LearnHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports